import React from "react";
import { useI18n } from "@/i18n";

export const STATUS_META = {
  received: { label: "Reçu", color: "#A1A1AA", border: "rgba(161,161,170,0.4)" },
  in_progress: { label: "En cours", color: "#FFB020", border: "rgba(253,224,71,0.5)" },
  completed: { label: "Terminé", color: "#00E5A0", border: "rgba(57,255,20,0.5)" },
  rejected: { label: "Refusé", color: "#E4002B", border: "rgba(255,0,60,0.5)" },
};

export const AnalyzingBadge = ({ testid }) => {
  const { t } = useI18n();
  return (
    <span
      data-testid={testid}
      className="inline-flex items-center gap-1.5 px-2.5 py-1 font-mono text-[10px] uppercase tracking-widest rounded-sm text-aurora-purple"
      style={{ border: "1px solid rgba(112,0,255,0.5)", background: "rgba(112,0,255,0.08)" }}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-aurora-purple animate-pulse-glow" />
      {t("status.analyzing")}
    </span>
  );
};

export const StatusPill = ({ status, testid }) => {
  const { t } = useI18n();
  const meta = STATUS_META[status] || STATUS_META.received;
  return (
    <span
      data-testid={testid}
      className="inline-flex items-center gap-1.5 px-2.5 py-1 font-mono text-[10px] uppercase tracking-widest rounded-sm"
      style={{ color: meta.color, border: `1px solid ${meta.border}`, background: `${meta.color}10` }}
    >
      <span className="w-1.5 h-1.5 rounded-full animate-pulse-glow" style={{ background: meta.color }} />
      {t(`status.${status}`)}
    </span>
  );
};
